import { Service } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Service()
export class CurrentMenuService {
    private _currentMenuWatch = new BehaviorSubject<CurrentMenu | null>(null);

    public currentMenu(): Observable<CurrentMenu | null> {
        return this._currentMenuWatch;
    }

    public set(id: string, title: string, subTitle: string): void {
        this._currentMenuWatch.next({
            id,
            title,
            subTitle
        });
    }

}

export class CurrentMenu {
    id: string;
    title: string;
    subTitle: string;
}